import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import config from '../../../config/config';
import { transactionShape } from '../../../utils/propTypes';
import { voidTransaction } from '../../Void/voidActions';
import { getIsVoidLoadingById } from '../../Void/voidEntity';
import { getIsCaptureLoadingById } from '../../Capture/captureEntity';
import { getCustomAccess, getDoesUserHaveWriteAccessForMerchant } from '../../Self/selfEntity';
import { captureTransaction } from '../../Capture/captureActions';
import { EmvioConfirmation } from '@nexio/emvio-util-ui';
import { EmvioButton } from '@nexio/emvio-form-components';
import { toggleModal } from '../../Modal/modalActions';
import { transactionType, transactionStatus } from '@nexio/emvio-util-app';
import { getIsRefundLoadingById } from '../../Refund/refundEntity';
import { refundTransaction } from '../../Refund/refundActions';
import { getIsApmConfigured } from '../../Merchants/merchantsEntity';
import { doesRoleHaveAccessToFeature } from '../../../utils/customRole';
import './Actions.scss';
import { getGateways } from '../../Gateways/gatewaysEntity';
import { getMerchantByMerchantId } from '../../MerchantManagement/merchantManagementEntity';
import { getApms } from '../../Apms/apmEntity';
import { isKount360 } from '../../../utils/gateways';

export class Actions extends Component {
    static propTypes = {
        className: PropTypes.string,
        doesUserHaveWriteAccess: PropTypes.bool,
        isCaptureLoading: PropTypes.bool,
        isVoidLoading: PropTypes.bool,
        isRefundLoading: PropTypes.bool,
        onCaptureTransaction: PropTypes.func,
        onRefundTransaction: PropTypes.func,
        onVoidTransaction: PropTypes.func,
        onOpenCapture: PropTypes.func,
        onOpenVoid: PropTypes.func,
        onOpenRefund: PropTypes.func,
        transaction: transactionShape,
        isVoided: PropTypes.bool,
        isCaptured: PropTypes.bool,
        isMerchantPaymentConfigured: PropTypes.bool,
        isMerchantApmConfigured: PropTypes.bool,
        chargeback: PropTypes.shape({
            authCode: PropTypes.string,
            cardNumber: PropTypes.string
        }),
        isChargebackLoading: PropTypes.bool,
        customAccess: PropTypes.any,
        gateways: PropTypes.any,
        apms: PropTypes.array,
        isFullyRefunded: PropTypes.bool,
        isLinkedRefundsLoading: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.popoverDeclineRef = React.createRef();
        this.declineButtonRef = React.createRef();
        this.popoverApproveRef = React.createRef();
        this.approveButtonRef = React.createRef();
    }

    handleDeclineTransaction = () => {
        this.popoverDeclineRef.current.openPopover(this.declineButtonRef.current);
    };

    handleApproveTransaction = () => {
        this.popoverApproveRef.current.openPopover(this.approveButtonRef.current);
    };

    getButtons = () => {
        const accessDeniedText = 'Insufficient access rights';

        const actionButtons = [];
        let kountId;
        let kountData;
        try {
            kountData = JSON.parse(_.get(this.props, 'transaction.kount.rules'));
            if (isKount360(kountData)) {
                kountId = _.get(kountData, 'order.orderId');
            } else {
                kountId = _.get(kountData, 'TRAN');
            }
        } catch (err) {
            kountId = null;
        }

        const currentTransactionStatus = _.get(this.props, 'transaction.transactionStatus');
        const transactionIsOpen = currentTransactionStatus === transactionStatus.authorized || currentTransactionStatus === transactionStatus.authOnly;
        const transactionIsFlaggedForReview = _.get(this.props, 'transaction.kount.status') === 'R';
        let kountLink;

        if (isKount360(kountData)) {
            kountLink = `${config.kount360TransactionUrl}/event-analysis/order/${kountId}`;
        } else {
            kountLink = `${config.kountTransactionUrl}?id=${kountId}`;
        }

        const voidButton = this.getVoidButton();
        const refundButton = this.getRefundButton();
        const captureButton = this.getCaptureButton();

        if (kountId) {
            actionButtons.push(
                <a
                    key="view-kount-btn"
                    href={kountLink}
                    className="kount-link"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    View In Kount
                </a>
            );
        }
        const isDeclineEnabled = this.props.doesUserHaveWriteAccess && doesRoleHaveAccessToFeature(this.props.customAccess, { [config.serviceArns.transaction]: ['POST/v3/void'] });

        const isCaptureEnabled = this.props.doesUserHaveWriteAccess && doesRoleHaveAccessToFeature(this.props.customAccess, { [config.serviceArns.transaction]: ['POST/v3/capture'] });

        if (transactionIsOpen && transactionIsFlaggedForReview && !this.props.isVoided && !this.props.isCaptured) {
            actionButtons.push(...[
                <EmvioButton
                    className="action-button kount-btn"
                    key="decline-btn"
                    invertColors
                    disabled={!isDeclineEnabled || this.props.isCaptureLoading}
                    isLoading={this.props.isVoidLoading}
                    onClick={this.handleDeclineTransaction}
                    title={!isDeclineEnabled ? accessDeniedText : null}
                    ref={this.declineButtonRef}
                    size="small">
                    Decline
                </EmvioButton>,
                <EmvioConfirmation
                    buttonText="Decline"
                    key="decline-confirmation"
                    onConfirm={this.props.onVoidTransaction(this.props.transaction)}
                    text="Are you sure you would like to decline this transaction?"
                    ref={this.popoverDeclineRef}
                />,
                <EmvioButton
                    className="action-button kount-btn"
                    key="approve-btn"
                    invertColors
                    disabled={!isCaptureEnabled || this.props.isVoidLoading}
                    isLoading={this.props.isCaptureLoading}
                    onClick={this.handleApproveTransaction}
                    title={!isCaptureEnabled ? accessDeniedText : null}
                    ref={this.approveButtonRef}
                    size="small">
                    Approve
                </EmvioButton>,
                <EmvioConfirmation
                    buttonText="Approve"
                    key="approve-confirmation"
                    onConfirm={this.props.onCaptureTransaction(this.props.transaction)}
                    title={!this.props.doesUserHaveWriteAccess ? accessDeniedText : null}
                    text="Are you sure you would like to approve this transaction?"
                    ref={this.popoverApproveRef}
                />
            ]);
        } else {
            if (voidButton && !this.props.isVoided) {
                actionButtons.push(voidButton);
            }
            if (captureButton && !this.props.isCaptured) {
                actionButtons.push(captureButton);
            }
        }

        if (refundButton) {
            actionButtons.push(refundButton);
        }

        return actionButtons;
    };

    getCaptureButton = () => {
        const transaction = this.props.transaction;
        const status = _.get(transaction, 'transactionStatus');
        const type = _.get(transaction, 'transactionType');

        const gateway = _.get(transaction, 'gateway.gatewayType');

        const validStatuses = [transactionStatus.authOnly];
        const validTypes = [transactionType.sale];
        const validGateways = this.props.gateways.gatewaysThatCanCapture;

        const validApms = this.props.apms
            .filter((apm) => apm.doesSupportCapture)
            .map((apm) => apm.connectorId);

        const isCaptureEnabled = this.props.doesUserHaveWriteAccess && doesRoleHaveAccessToFeature(this.props.customAccess, { [config.serviceArns.transaction]: ['POST/v3/capture'] });

        let isMerchantEnabledForCaptureVoidRefund;

        if (_.includes(validApms, gateway)) {
            isMerchantEnabledForCaptureVoidRefund = this.props.isMerchantApmConfigured;
        } else if (_.includes(validGateways, gateway)) {
            isMerchantEnabledForCaptureVoidRefund = this.props.isMerchantPaymentConfigured;
        } else {
            isMerchantEnabledForCaptureVoidRefund = false;
        }

        if (_.includes(validStatuses, status)
            && _.includes(validTypes, type)
            && (_.includes(validGateways, gateway) || _.includes(validApms, gateway))) {
            return (
                <EmvioButton
                    className="action-button capture-btn"
                    key="capture-btn"
                    invertColors
                    disabled={!isCaptureEnabled || this.props.isCaptureLoading || !isMerchantEnabledForCaptureVoidRefund}
                    isLoading={this.props.isCaptureLoading}
                    onClick={() => this.props.onOpenCapture(this.props.transaction)}
                    title={this.getAccessDeniedText(isCaptureEnabled, isMerchantEnabledForCaptureVoidRefund)}
                    ref={this.approveButtonRef}
                    size="small">
                    Capture
                </EmvioButton>
            );
        } else {
            return null;
        }
    };

    getRefundButton = () => {
        const {
            doesUserHaveWriteAccess,
            isCaptureLoading,
            isVoidLoading,
            chargeback,
            isChargebackLoading,
            isRefundLoading,
            transaction,
            customAccess,
            gateways,
            isFullyRefunded,
            isLinkedRefundsLoading
        } = this.props;

        const status = _.get(transaction, 'transactionStatus');
        const type = _.get(transaction, 'transactionType');
        const gateway = _.get(transaction, 'gateway.gatewayType');
        const amount = _.get(transaction, 'amount');

        const validTypes = [transactionType.sale];

        const validGateways = gateways.gatewaysThatCanRefund;

        const validApms = this.props.apms
            .filter((apm) => apm.doesSupportRefund)
            .map((apm) => apm.connectorId);

        const isRefundEnabled = doesUserHaveWriteAccess && doesRoleHaveAccessToFeature(customAccess, { [config.serviceArns.transaction]: ['POST/v3/refund'] });

        let isMerchantEnabledForCaptureVoidRefund;

        if (_.includes(validApms, gateway)) {
            isMerchantEnabledForCaptureVoidRefund = this.props.isMerchantApmConfigured;
        } else if (_.includes(validGateways, gateway)) {
            isMerchantEnabledForCaptureVoidRefund = this.props.isMerchantPaymentConfigured;
        } else {
            isMerchantEnabledForCaptureVoidRefund = false;
        }

        if (status === transactionStatus.settled
            && _.includes(validTypes, type)
            && (_.includes(validGateways, gateway) || _.includes(validApms, gateway))) {
            return (
                <EmvioButton
                    className="action-button refund-btn"
                    key="refund-btn"
                    invertColors
                    disabled= {
                        !isRefundEnabled || isCaptureLoading || isVoidLoading || !isMerchantEnabledForCaptureVoidRefund ||
                        !!chargeback || isChargebackLoading || amount === 0 || isLinkedRefundsLoading || isFullyRefunded
                    }
                    isLoading={isRefundLoading || isChargebackLoading}
                    onClick={() => this.props.onOpenRefund(transaction)}
                    title={this.getAccessDeniedText(isRefundEnabled, isMerchantEnabledForCaptureVoidRefund, chargeback)}
                    ref={this.refundButtonRef}
                    size="small">
                    Refund
                </EmvioButton>
            );
        } else {
            return null;
        }
    };

    getVoidButton = () => {
        const transaction = this.props.transaction;
        const gateways = this.props.gateways;
        const status = _.get(transaction, 'transactionStatus');
        const type = _.get(transaction, 'transactionType');
        const gateway = _.get(transaction, 'gateway.gatewayType');

        const validTypes = [transactionType.sale];

        const validGateways = [];
        _.forEach(gateways.gatewaysThatCanVoid, function (gateway) {
            if (_.includes(gateway.validStatuses, transactionStatus.authOnly) && _.includes(gateway.validStatuses, transactionStatus.authorized)) {
                validGateways.push(gateway.gatewayType);
            }
        });
        const validGatewaysAuthOnly = [];
        _.forEach(gateways.gatewaysThatCanVoid, function (gateway) {
            if (_.includes(gateway.validStatuses, transactionStatus.authOnly) && !_.includes(gateway.validStatuses, transactionStatus.authorized)) {
                validGatewaysAuthOnly.push(gateway.gatewayType);
            }
        });
        const validGatewaysAuthorized = [];
        _.forEach(gateways.gatewaysThatCanVoid, function (gateway) {
            if (!_.includes(gateway.validStatuses, transactionStatus.authOnly) && _.includes(gateway.validStatuses, transactionStatus.authorized)) {
                validGatewaysAuthorized.push(gateway.gatewayType);
            }
        });

        const validApms = this.props.apms
            .filter((apm) => apm.doesSupportVoid)
            .map((apm) => apm.connectorId);

        const isVoidEnabled = this.props.doesUserHaveWriteAccess && doesRoleHaveAccessToFeature(this.props.customAccess, { [config.serviceArns.transaction]: ['POST/v3/void'] });
        const validGatewaysByStatuses = {
            [transactionStatus.authOnly]: [...validGateways, ...validGatewaysAuthOnly],
            [transactionStatus.authorized]: [...validGateways, ...validGatewaysAuthorized]
        };

        const validApmsForStatuses = {
            [transactionStatus.authOnly]: [...validApms],
            [transactionStatus.authorized]: [...validApms]
        };

        const isGatewayValid = _.includes(_.get(validGatewaysByStatuses, `${status}`), gateway);
        const isApmValid = _.includes(_.get(validApmsForStatuses, `${status}`), gateway);

        let isMerchantEnabledForCaptureVoidRefund;

        if (isApmValid) {
            isMerchantEnabledForCaptureVoidRefund = this.props.isMerchantApmConfigured;
        } else if (isGatewayValid) {
            isMerchantEnabledForCaptureVoidRefund = this.props.isMerchantPaymentConfigured;
        } else {
            isMerchantEnabledForCaptureVoidRefund = false;
        }
        if ((isGatewayValid || isApmValid) && _.includes(validTypes, type)) {
            return (
                <EmvioButton
                    className="action-button void-btn"
                    key="void-btn"
                    invertColors
                    disabled={!isVoidEnabled || this.props.isCaptureLoading || !isMerchantEnabledForCaptureVoidRefund}
                    isLoading={this.props.isVoidLoading}
                    onClick={() => this.props.onOpenVoid(this.props.transaction)}
                    title={this.getAccessDeniedText(isVoidEnabled, isMerchantEnabledForCaptureVoidRefund)}
                    ref={this.declineButtonRef}
                    size="small">
                    Void
                </EmvioButton>
            );
        } else {
            return null;
        }
    };

    getAccessDeniedText = (doesUserHaveWriteAccess, isMerchantPaymentConfigured, chargeback) => {
        let accessDeniedText = '';

        if (!doesUserHaveWriteAccess) {
            accessDeniedText = 'Insufficient access rights';
        } else if (!isMerchantPaymentConfigured) {
            accessDeniedText = 'To enable the void, capture, or refund feature, please contact Customer Support at 877-267-4324';
        } else if (chargeback) {
            accessDeniedText = 'Refund disabled due to associated chargeback';
        }

        return accessDeniedText;
    };

    render() {

        return (
            <div className="actions">
                {this.getButtons()}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const id = _.get(ownProps.transaction, 'id');
    const merchantId = _.get(ownProps.transaction, 'merchantId');

    return {
        doesUserHaveWriteAccess: getDoesUserHaveWriteAccessForMerchant(state, merchantId),
        isMerchantPaymentConfigured: !!getMerchantByMerchantId(state, merchantId),
        isMerchantApmConfigured: getIsApmConfigured(state, merchantId),
        isCaptureLoading: getIsCaptureLoadingById(state, id),
        isVoidLoading: getIsVoidLoadingById(state, id),
        isRefundLoading: getIsRefundLoadingById(state, id),
        customAccess: getCustomAccess(state),
        gateways: getGateways(state),
        apms: getApms(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onCaptureTransaction: (transaction) => () => dispatch(captureTransaction(transaction)),
        onOpenCapture: (transaction) => dispatch(toggleModal('capture', transaction)),
        onVoidTransaction: (transaction) => () => dispatch(voidTransaction(transaction)),
        onOpenVoid: (transaction) => dispatch(toggleModal('void', transaction)),
        onRefundTransaction: (transaction) => () => dispatch(refundTransaction(transaction)),
        onOpenRefund: (transaction) => dispatch(toggleModal('refund', transaction))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Actions);
